import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
// const baseURL = "http://localhost:3014";
const baseURL = "https://atcgn.lkm.accenture.com/atcgn-api";

export const FAQSlice = createSlice({
 name: "faqdata",
 initialState: {
  error: false,
  faqlist: [],
  adminList: [],
  isAdminPresent: false,
 },
 reducers: {
  setSubmittedData: (state, { payload }) => {
   state.error = false;
   const lastId =
    state.faqlist.length > 0 ? state.faqlist[state.faqlist.length - 1].id : 0;

   const data = payload.map((val, i) => {
    return { ...val, id: lastId + i + 1 };
   });
   console.log("Data", data);
   console.log("payload", payload);

   state.faqlist = [...state.faqlist, ...data];
   console.log("state.faqlist", state.faqlist);
  },
  setData: (state, { payload }) => {
   state.error = false;
   state.faqlist = payload;
  },
  setAdminList: (state, { payload }) => {
   state.error = false;
   state.adminList = payload;
  },
  setDataDeletion: (state, { payload }) => {
   state.error = false;

   const filteredData = state.faqlist.filter((val) => val.id != payload);
   state.faqlist = filteredData;
  },
  updateAdminList: (state, { payload }) => {
   state.error = false;
   const newUser = {
    enterpriseID: payload,
   };
   const data = [...state.adminList, newUser];
   state.adminList = data;
  },

  updateAdminPermission: (state, { payload }) => {
   console.log("pay", payload, payload.length);
   state.isAdminPresent = payload.length > 0 ? true : false;
  },
  setError: (state) => {
   state.error = true;
  },
 },
});

// Action creators are generated for each case reducer function
export const {
 setError,
 setData,
 setSubmittedData,
 setDataDeletion,
 setAdminList,
 updateAdminList,
 updateAdminPermission,
} = FAQSlice.actions;

export default FAQSlice.reducer;

export function addFaqData(qaList) {
 return (dispatch) => {
  axios
   .post(
    `${baseURL}/submitfaq`,
    { qaList },
    {
     headers: {
      Authorization: localStorage.getItem("token"),
      "Content-Type": "application/json",
     },
    }
   )
   .then((res) => {
    console.log("success", res.data);
    dispatch(setSubmittedData(qaList));
   })
   .catch((err) => {
    console.error("failed to fetch");
   });
 };
}

export function fetchFAQData() {
 return (dispatch) => {
  axios
   .get(
    `${baseURL}/fetchfaq`,

    {
     headers: {
      Authorization: localStorage.getItem("token"),
      "Content-Type": "application/json",
     },
    }
   )
   .then((res) => {
    dispatch(setData(res.data));
   })
   .catch((err) => {
    console.error("failed to fetch");
   });
 };
}
export function deleteData(deleteId) {
 return (dispatch) => {
  axios
   .post(
    `${baseURL}/delete`,
    { deleteId },

    {
     headers: {
      Authorization: localStorage.getItem("token"),
      "Content-Type": "application/json",
     },
    }
   )
   .then((res) => {
    dispatch(setDataDeletion(deleteId));
   })
   .catch((err) => {
    console.error("failed to fetch");
   });
 };
}
export function upload(formData) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/uploadfile`, formData, {
    headers: {
     Authorization: localStorage.getItem("token"),
    },
   })
   .then((res) => {
    // then print response status
    console.log(res);
   })
   .catch((err) => {
    // then print response status
    console.error("upload fail");
   });
 };
}
export function fetchAdminUsers() {
 return (dispatch) => {
  axios
   .get(`${baseURL}/fecthAdmin`, {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   })
   .then((res) => {
    dispatch(setAdminList(res.data));
    console.log(res);
   })
   .catch((err) => {
    // then print response status
    console.error("upload fail");
   });
 };
}
export function addEnterprise(name) {
 return (dispatch) => {
  axios
   .get(`${baseURL}/submitID/${name}`, {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   })
   .then((res) => {
    dispatch(updateAdminList(name));
    console.log(res);
   })
   .catch((err) => {
    // then print response status
    console.error("upload fail");
   });
 };
}
export function checkadmin(name) {
 return (dispatch) => {
  axios
   .get(`${baseURL}/checkadmin/${name}`, {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   })
   .then((res) => {
    dispatch(updateAdminPermission(res.data));
    console.log(res);
   })
   .catch((err) => {
    // then print response status
    console.error("upload fail");
   });
 };
}
